import { render, staticRenderFns } from "./CoursesDropdown.vue?vue&type=template&id=2f74b895"
import script from "./CoursesDropdown.vue?vue&type=script&lang=js"
export * from "./CoursesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports